<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pTi8XX/images/9781401396374.jpg?1731772123235" alt="This image is the cover for the book Delicate Edible Birds"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Delicate Edible Birds
      </h1>
      <p class="bookDescription body article font2">
        <b>“Richly conceived, finely detailed stories . . . of smart, daring women who are in search of, in thrall to, or disillusioned by love” (<i>Booklist</i>).</b><br/><br/><b>“Nine wildly unique, exquisitely symphonic tales, full of beauty, tragedy, and the sudden horror of shocking images—this is Groff’s gift to readers. And what a gift it is.” —<i>Library Journal</i></b><br/><br/>From Lauren Groff, author of the critically acclaimed and <i>New York Times</i> bestselling novel <i>Fates and Furies</i>, comes <i>Delicate Edible Birds</i>, one of the most striking short fiction debuts in years. Here are nine stories of astonishing insight and variety, each revealing a resonant drama within the life of a twentieth-century American woman.<br/><br/><b>“[An] innovative and beautifully written collection that covers a wide swath of humanity, from east coast resort towns, to the early twentieth century flu epidemic, to WWII Europe.” —<i>Publishers Weekly</i></b><br/><br/><b>“Tales of ordinary transformations and everyday occurrences are made magical in a collection of nine stories by Groff. . . . Groff’s skill makes commonplace occurrences seem compelling.” —<i>Kirkus Reviews</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lauren Groff
      </h2>
      
      <p class="authorDescription body article"><B>Lauren Groff</B> is the author of <I>The Monsters of Templeton</I>, shortlisted for the Orange Prize for New Writers; <I>Arcadia</I>, a <I>New York Times</I> Notable Book, winner of the Medici Book Club Prize, and finalist for the L.A. Times Book Award; and Fates and Furies, a National Book Award finalist. Her writing has appeared in the <I>New Yorker</I>, the <I>Atlantic Monthly, Harper's, Tin House, One Story, McSweeney's</I>, and <I>Ploughshares</I>, and in the anthologies <I>100 Years of the Best American Short Stories, The Pushcart Prize: Best of the Small Presses, PEN/O. Henry Prize Stories</I>, and three editions of <I>The Best American Short Stories</I>. She lives in Gainesville, Florida, with her husband and two sons.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Hachette Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f3679cf0